export default __webpack_public_path__ + "17826cef2490602adb49d23c16e6b560.png";